export const createRoute = (
    bookingId = ':booking'
) => `booking/add-contact/${bookingId}`;

export const detailRoute = (
    contactId = ':contact'
) => `legacy-crm/contact/${contactId}`;
